export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-myspace-9168cfa895576920624ae2ab23cf62ed.svg";